import { incrementCounter } from "../app/slices/appSlice";
import { Button } from "./Button";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { ReactElement } from "react";
import { CommonState } from "../app/interfaces/common";
import { getNextPromoCode } from "../app/utils/promocode";
import { CodeLock } from "./CodeLock";
import { ymEvent } from "../app/utils/metrix";

export const Game = (): ReactElement => {
  const dispatch = useAppDispatch()
  const {count, code} = useAppSelector((state: CommonState) => state.app)

  const nextPromoCode = getNextPromoCode(code)

  return (
    <div className={'game'}>
      <div className={'pb_game bubble bubble_purple bubble_bottom'}>
        <h1 className={'headline font_beige desk'}>Жми на кнопку и выжимай выгоду!</h1>
        <h1 className={'headline font_beige mob'}>Жми и выжимай выгоду!</h1>
        <div className={'font_white'}>
          <span className={'game__target'}>Цель: {nextPromoCode.clicks} кликов</span><br/>
          <span className={'game__cta'}>Получи выгоду в {nextPromoCode.value} при покупке от {nextPromoCode.purchase} рублей</span>
        </div>
        <CodeLock code={count}/>
      </div>
      <div className={'game__machine-wrap'}>
        <div className={'game__machine'}>
          <div className={'game__wires'}/>
        </div>
      </div>
      <Button cssClass={'button_game-action button_green'} clickEvent={() => {ymEvent('game_action_click'); dispatch(incrementCounter())}}>Выжми</Button>
    </div>
  )
}